import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import { useNavigate } from "react-router-dom";
const QrGenerator = () => {
  const [qrPlay, setQrPlay] = useState("");
  const [qrAppStore, setQrAppStore] = useState("");
const navigate = useNavigate();
  const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.ta.wallet.tawallet&hl=en_IN";

  const APP_STORE_URL =
    "https://apps.apple.com/in/app/ta-wallet/id1381087275";

  useEffect(() => {
    // Generate QR codes with higher quality and margin
    const qrOptions = { width: 180, margin: 2, color: { dark: "#1e293b" } };

    QRCode.toDataURL(PLAY_STORE_URL, qrOptions)
      .then((url) => setQrPlay(url))
      .catch((err) => console.error(err));

    QRCode.toDataURL(APP_STORE_URL, qrOptions)
      .then((url) => setQrAppStore(url))
      .catch((err) => console.error(err));
  }, []);

  const s = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "#f8fafc",
      minHeight: "100vh",
      fontFamily: "'Inter', system-ui, sans-serif",
    },
    header: {
      marginBottom: "40px",
    },
    title: {
      fontSize: "32px",
      fontWeight: "800",
      color: "#0f172a",
      margin: "0 0 10px 0",
    },
    subtitle: {
      color: "#64748b",
      fontSize: "16px",
      maxWidth: "500px",
      margin: "0 auto",
    },
    grid: {
      display: "flex",
      justifyContent: "center",
      gap: "30px",
      flexWrap: "wrap",
      marginTop: "20px",
    },
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "24px",
      padding: "30px",
      width: "280px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
      border: "1px solid #f1f5f9",
      transition: "transform 0.3s ease",
    },
    qrWrapper: {
      padding: "15px",
      backgroundColor: "#f8fafc",
      borderRadius: "16px",
      display: "inline-block",
      marginBottom: "20px",
      border: "1px solid #e2e8f0",
    },
    platformBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "8px 16px",
      borderRadius: "12px",
      fontSize: "14px",
      fontWeight: "600",
      marginBottom: "15px",
    },
    instruction: {
      fontSize: "13px",
      color: "#94a3b8",
      marginTop: "10px",
    }
  };

  return (
    <div style={s.container}>
        {/* ✅ BACK BUTTON */}
  <div style={{ textAlign: "left", marginBottom: "20px" }}>
<button
  onClick={() => navigate(-1)}
  style={{
    background: "white",
    border: "none",
    marginLeft: "80px",
    color: "#1d4f18",
    fontWeight: "800",
    fontSize: "20px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px"
  }}
>
  <i className="bi bi-arrow-left" ></i> Back
</button>
  </div>
      <header style={s.header}>
        
        <h2 style={s.title}>Download Our App</h2>
        <p style={s.subtitle}>
          Scan the QR code below with your smartphone camera to download the TA Wallet instantly.
        </p>
      </header>

      <div style={s.grid}>
        {/* Google Play Card */}
        <div style={s.card} onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"} onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
          <div style={{ ...s.platformBadge, backgroundColor: "#ecfdf5", color: "#059669" }}>
           Google Play
          </div>
          <div style={s.qrWrapper}>
            {qrPlay ? <img src={qrPlay} alt="Play Store QR" style={{ width: "100%", borderRadius: "8px" }} /> : "Loading..."}
          </div>
          <div style={{ fontWeight: "700", color: "#1e293b" }}>Android Users</div>
          <p style={s.instruction}>Scan to browse the Play Store</p>
        </div>

        {/* App Store Card */}
        <div style={s.card} onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"} onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
          <div style={{ ...s.platformBadge, backgroundColor: "#f1f5f9", color: "#1e293b" }}>
           App Store
          </div>
          <div style={s.qrWrapper}>
            {qrAppStore ? <img src={qrAppStore} alt="App Store QR" style={{ width: "100%", borderRadius: "8px" }} /> : "Loading..."}
          </div>
          <div style={{ fontWeight: "700", color: "#1e293b" }}>iOS Users</div>
          <p style={s.instruction}>Scan to browse the App Store</p>
        </div>
      </div>

      <footer style={{ marginTop: "50px", color: "#cbd5e1", fontSize: "12px" }}>
        © {new Date().getFullYear()} Transaction Analysts • Secure Payments Everywhere
      </footer>
    </div>
  );
};

export default QrGenerator;